export default "__VITE_ASSET__CgLYMonM__"